import { DownloadSimpleIcon } from "@phosphor-icons/react";

import type { SafetyProfilePayload } from "@miter/types/contracts";
import { Button } from "ui2";

import { ProfileSection } from "safety/components/profile/ProfileSection";

type DocumentsSectionProps = {
  documents: NonNullable<SafetyProfilePayload["documents"]>;
};

export const DocumentsSection = ({ documents }: DocumentsSectionProps): React.JSX.Element => (
  <ProfileSection title="Documents">
    {documents.map((document, index) => (
      <div
        key={index}
        className="tw:flex tw:items-center tw:justify-between tw:gap-4 tw:border-b tw:border-stroke tw:px-4 tw:py-3 tw:last:border-b-0"
      >
        <span className="tw:min-w-0 tw:flex-1 tw:truncate tw:text-sm tw:text-midnight">{document.label}</span>
        <Button asChild variant="outline">
          <a href={document.download_url} target="_blank" rel="noopener noreferrer">
            <DownloadSimpleIcon weight="bold" />
            Download
          </a>
        </Button>
      </div>
    ))}
  </ProfileSection>
);
